import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', name: 'home', component: () => import('../pages/Home.vue') },
    { path: '/access', name: 'access', component: () => import('../pages/Access.vue') },
    { path: '/institution/data', name: 'institution', component: () => import('../pages/Main.vue') },
    { path: '/institution/documents', name: 'documents', component: () => import('../pages/Lines.vue') },
    { path: '/institution/reports', name: 'reports', component: () => import('../pages/Reports.vue') },
  ],
})

export default router
